export const childrenPaths = []

export default [
  {
    path: "/sprints/",
    name: "Timed release templates",
    meta: {
      title: "Sprints",
      icon: "bhi-clock",
      requiresAuth: true
    },
    component: () => import("@/views/TimedReleaseTemplates.vue"),
  },
  {
    path: "/sprints/:id",
    name: "Template",
    hidden: true,
    meta: {
      title: "Sprints",
      icon: "bhi-clock",
      requiresAuth: true
    },
    component: () => import("@/views/TimedReleaseTemplate.vue"),
  },
]